import React from "react";
import styled from "styled-components";

const TruncatedSpan = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  cursor: pointer;
`;

export { TruncatedSpan };